import { Environment } from '@abp/ng.core';

type RuntimeEnvironment = {
  production?: boolean | string;
  baseUrl?: string;
  appName?: string;
  logoUrl?: string;
  oAuthIssuer?: string;
  oAuthClientId?: string;
  oAuthScope?: string;
  apiUrl?: string;
  apiRootNamespace?: string;
  mercadoPagoPublicKey?: string;
  paywayPublicKey?: string;
  paywayEnv?: string;
  useRefreshToken?: boolean | string;
};

declare global {
  interface Window {
    __env?: RuntimeEnvironment;
  }
}

export const environment = {
  production: false,
  application: {
    baseUrl: 'http://localhost:4200',
    name: 'WinePassport',
    logoUrl: '',
  },
  oAuthConfig: {
    issuer: 'https://localhost:44332/',
    redirectUri: 'http://localhost:4200',
    clientId: 'WinePassport_App',
    scope: 'openid profile email offline_access WinePassport',
    useRefreshToken: true,
    dummyClientSecret: "",
    postLogoutRedirectUri: 'http://localhost:4200'
  },
  apis: {
    default: {
      url: 'https://localhost:44332',
      rootNamespace: 'WinePassport',
    },
  },
  mercadoPago: {
    publicKey: ''
  },
  payway: {
    publicKey: '9ZiAulIeUZ7xvR9NeuoECA3eT0nJhy3e',
    env: 'sandbox'
  }
} as Environment;

if (typeof window !== 'undefined' && window.__env) {
  const runtime = window.__env;
  if (runtime.baseUrl) {
    environment.application.baseUrl = runtime.baseUrl;
    environment.oAuthConfig.redirectUri = runtime.baseUrl;
    environment.oAuthConfig.postLogoutRedirectUri = runtime.baseUrl;
  }
  if (runtime.appName) environment.application.name = runtime.appName;
  if (runtime.logoUrl) environment.application.logoUrl = runtime.logoUrl;
  
  if (runtime.apiUrl) {
    environment.apis.default.url = runtime.apiUrl;
  }
  
  const apiUrl = runtime.apiUrl || 'https://localhost:44332';
  const oAuthIssuer = runtime.oAuthIssuer || `${apiUrl}/`;
  environment.oAuthConfig.issuer = oAuthIssuer.endsWith('/') ? oAuthIssuer : `${oAuthIssuer}/`;

  if (runtime.oAuthClientId) environment.oAuthConfig.clientId = runtime.oAuthClientId;
  if (runtime.oAuthScope) environment.oAuthConfig.scope = runtime.oAuthScope;
  if (runtime.useRefreshToken !== undefined) {
    (environment.oAuthConfig as any).useRefreshToken = runtime.useRefreshToken === true || runtime.useRefreshToken === 'true';
  }
  if (runtime.apiRootNamespace) environment.apis.default.rootNamespace = runtime.apiRootNamespace;
  if (runtime.mercadoPagoPublicKey) environment.mercadoPago.publicKey = runtime.mercadoPagoPublicKey;
  if (runtime.paywayPublicKey) (environment as any).payway.publicKey = runtime.paywayPublicKey;
  if (runtime.paywayEnv) (environment as any).payway.env = runtime.paywayEnv;
  if (runtime.production !== undefined) {
    environment.production = runtime.production === true || runtime.production === 'true';
  }
}

